export default __webpack_public_path__ + "static/media/ScanCollectImg.a2ff7f28.png";